/**
 * jai1 tasks pick [-j]
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { confirm } from '@inquirer/prompts';
import { TaskService } from '../../services/task.service.js';
import { PRIORITY_ICONS, type TaskPickOptions } from '../../types/task.types.js';

export function createTaskPickCommand(): Command {
    return new Command('pick')
        .description('Claim the next available task')
        .option('-j, --json', 'Output JSON')
        .action(async (options: TaskPickOptions) => {
            const service = new TaskService();
            const ready = await service.getReady();

            if (ready.length === 0) {
                if (options.json) {
                    console.log(JSON.stringify({ picked: null, message: 'No tasks ready' }));
                    return;
                }
                console.log(chalk.dim('No tasks ready to pick.'));
                console.log(chalk.dim('💡 Add tasks first: jai1 t add "..."'));
                return;
            }

            const top = ready[0]!;
            const icon = PRIORITY_ICONS[top.priority] || '🟡';

            if (options.json) {
                // Non-interactive: auto-pick first
                const picked = await service.pick(top.id);
                console.log(JSON.stringify(picked, null, 2));
                return;
            }

            console.log(chalk.bold('\n📌 Next available task:'));
            console.log(`   ${chalk.bold(top.id)}  P${top.priority}${icon}  ${top.title}`);
            if (top.parent) {
                console.log(`   ${chalk.dim('Parent:')} ${top.parent}`);
            }

            if (ready.length > 1) {
                console.log(chalk.dim(`\n   +${ready.length - 1} more tasks ready`));
            }

            const proceed = await confirm({
                message: 'Claim this task?',
                default: true,
            });

            if (!proceed) {
                console.log(chalk.dim('\nCancelled.'));
                return;
            }

            const picked = await service.pick(top.id);
            console.log(chalk.green(`\n✅ ${picked.id} assigned to @${picked.assigned_to}, status → in_progress`));
        });
}
